import { GeneralPermissions } from "@redotech/account-common/permissions";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

export const developerChildRoutes: PermissionedRouteObject[] = [
  {
    path: "functions",
    handle: { breadcrumb: "Functions" },
    async lazy() {
      const { FunctionsListPage } =
        await import("./functions/functions-list-page");
      return { Component: FunctionsListPage };
    },
  },
  {
    path: "connections",
    handle: {
      breadcrumb: "Connections",
      permission: [GeneralPermissions.MANAGE_TEAM_DEVELOPMENT],
    },
    async lazy() {
      const { ConnectionsPage } =
        await import("./connections/connections-page");
      return { Component: ConnectionsPage };
    },
  },
  {
    path: "logs",
    handle: {
      breadcrumb: "Logs",
      permission: GeneralPermissions.MANAGE_TEAM_DEVELOPMENT,
    },
    async lazy() {
      const { DeveloperLogsPage } = await import("./logs/developer-logs-page");
      return { Component: DeveloperLogsPage };
    },
  },
];
